/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import Vue from 'vue'

import { DONT_CALL_INTERCOM } from '@/constants/orderParameters'
import { PAYMENT_TYPES } from '@/constants/paymentTypes'
import { getCallingGuest, getCallingPhone } from '@/helpers/guest'
import unitePayments from '@/utils/unitePaymentTypes'
import useFormat from '@/views/utils'

import mutationsContractors from './contractors/mutations'

const { formatDateForPickr } = useFormat()

const blankOrder = {
    num: 'Новый заказ',
    status: { name: '' },
    brand_id: null,
    source: {
        id: '',
        name: '',
    },
    sector: {},
    created_date: null,
    delivered_date: null,
    delivered_date_format: null,
    delivered_fact_date: null,
    order_type: {},
    time_type: 'asap',
    payments: [],
    promos: [],
    guest: null,
    restaurant: null,
    address: {},
    dishes: [],
    ticket_time: 0,
    cooking_time: 0,
    delivery_time: 0,
    standard_cooking_time: 0,
    standard_delivery_time: 0,
    over_time: 0,
    editable: true,
    lock_by_user: null,
    courier: {},
    sector_id: null,
    order_time: null,
    errors: [],
    division_id: null,
    parameters: [],
    send_notification: true,
    contractor: null,
}

const blankAddress = {
    region_id: null,
    city: null,
    street: null,
    house: null,
    longitude: null,
    latitude: null,
    flat: null,
    entrance: null,
    floor: null,
    intercom: null,
}

const dateCompare = (d1, d2) => {
    const date1 = new Date(d1)
    const date2 = new Date(d2)

    if (date1 > date2) {
        return false
    }
    if (date1 < date2) {
        return false
    }
    return true
}
export default {
    ...mutationsContractors,

    SET_BRANDS(state, brands) {
        state.brands = brands
    },

    ADD_TO_DISCOUNTS(state, { data }) {
        state.discounts = data.pds_discount
    },

    ADD_TO_TYPES(state, { data }) {
        state.types = []
        state.paymentTypes = []
        data.eds_order_type.forEach(e => {
            state.types.push({
                id: e.id,
                name: e.name,
                disabled: !e.active,
            })
            state.paymentTypes.push({
                id: e.id,
                types: unitePayments(e.order_type_payment_type_source_links),
            })
        })
    },

    SET_RESTAURANTS(state, restaurants) {
        state.restaurants = restaurants
    },

    SET_SECTORS(state, sectors) {
        state.sectors = []
        if (!sectors) state.sectors = []
        sectors.forEach(e => {
            state.sectors.push({
                id: e.id,
                name: e.name,
            })
        })
    },

    SET_INTERVALS(state, intervals) {
        state.deliveryIntervalsV2 = intervals || []
    },

    SET_SETCORS_FOR_SELECT(state, sectors) {
        state.sectorsForSelect = sectors
    },

    SET_RESTAURANT_FOR_SELECT(state, restaurants) {
        state.restaurantsForSelect = restaurants
    },

    SET_REGIONS(state, { data }) {
        data.region?.forEach(e => {
            state.regions.push({
                id: e.id,
                name: e.name,
                kladr_id: e.kladr_id,
                latitude: e.latitude,
                longitude: e.longitude,
            })
        })
    },

    SET_GUEST_ID(state, { id }) {
        state.order.guest_id = id
    },
    SET_GUEST(state, guest) {
        state.order.guest = guest
    },
    SET_GUEST_LAST_MODIFIED_DATE(state, val) {
        state.order.guest.last_modified_date = val
    },
    SET_GUEST_CONTACTS(state, val) {
        if (state.order.guest) state.order.guest.contacts = val
    },
    SET_PHONE(state, { phone }) {
        state.order.phone = phone
    },

    CLEAR_GUEST_TO_ORDER(state) {
        state.order.guest = null
    },

    SET_DELIVERED_DATE(state, deliveredDate) {
        state.order.delivered_date = deliveredDate
    },
    SET_DELIVERED_DATE_FORMAT(state, deliveredDate) {
        state.order.delivered_date_format = deliveredDate
    },

    UPDATE_ORDER(state, order) {
        state.order = order
    },
    UPDATE_ORDER_AFTER_RECALC(state, order) {
        state.order = {
            ...state.order,
            payments: order.payments,
            dishes: order.dishes,
            promos: order.promos,
        }
    },

    NEW_ORDER(state, { data, options = {} }) {
        const [statuses, source, brand] = data
        const statusName = options.isStaff ? 'Редактируется' : 'Черновик'
        const callingGuest = getCallingGuest(state.guest_calling)

        const foundStatus = statuses.find(s => s.name === statusName)

        const order = {
            ...structuredClone(blankOrder),
            address: structuredClone(blankAddress),
            status: foundStatus || { name: statusName, id: null },
            status_id: foundStatus?.id ?? null,
            source,
            source_id: source.id,
            brand_id: brand?.id,
            editable: true,
        }

        if (options.isStaff) {
            order.division_id = options.divisionId
            order.guest = options.guest
            order.guest_id = options.guest?.id
            order.phone = options.phone

            if (options.order_type) {
                order.order_type = options.order_type
            }
        } else if (callingGuest) {
            order.guest_id = callingGuest.id
            order.guest = callingGuest
            order.phone = getCallingPhone(state.guest_calling)
        }

        state.order = order
    },

    SET_STATUSES(state, statuses) {
        state.statuses = statuses
    },

    SET_ORDER(state, { order, lock_by_user }) {
        state.order = { ...blankOrder, ...order }
        if (!state.order.parameters) {
            state.order.parameters = []
        }

        if (!state.order.payments) state.order.payments = []
        if (!state.order.promos) state.order.promos = []
        if (!state.order.dishes) state.order.dishes = []
        if (!state.order.address) state.order.address = { region_id: null }
        if (state.order.delivered_date)
            state.order.delivered_date_format = formatDateForPickr(
                new Date(state.order.delivered_date)
            )
        if (lock_by_user) {
            state.order.lock_by_user = lock_by_user
            state.order.editable = false
        } else {
            state.order.editable = true
        }
    },

    SET_DISHES(state, { dishes }) {
        state.order.dishes = dishes
    },

    UPDATE_ORDER_AFTER_ADD(state, { order }) {
        state.order.status = state.statuses.find(e => e.id === order.status_id)
        state.order.status_id = order.status_id
        state.order.num = order.num
        state.order.id = order.id
        state.order.address.id = order.address_id
        if (!dateCompare(state.order.delivered_date, order.delivered_date))
            state.order.delivered_date = order.delivered_date
        state.order.created_date = order.created_date
        state.order.operator = order.operator
        if (order.lock_by_user) {
            state.order.lock_by_user = order.lock_by_user
            state.order.editable = false
        } else {
            state.order.editable = true
        }

        state.order.payments = order.payments ? order.payments : []
        state.order.promos = order.promos ? order.promos : []
    },

    SET_PERMISSIONS(state, { permissions }) {
        if (permissions) {
            permissions.forEach(e => {
                const elems = e.split('.')
                const entity = elems[0]
                const action = elems[1]

                if (action === 'write') {
                    state.permissions.write.push(entity)
                }

                if (action === 'read') {
                    state.permissions.read.push(entity)
                }
            })
        } else {
            state.permissions.write = []
            state.permissions.read = []
        }
    },

    UPDATE_ORDER_AFTER_PUT(state, { order, lock_by_user }) {
        state.order.status = order.status
        state.order.status_id = order.status_id
        state.order.source_id = order.source_id
        if (!state.dirtiesAttributes.includes('delivered_date')) {
            state.order.delivered_date = order.delivered_date
        }
        state.order.payments = order.payments ? order.payments : []
        state.order.promos = order.promos ? order.promos : []
        state.order.operator = order.operator
        state.order.dishes = order.dishes || []
        state.order.order_time = order.order_time

        if (
            order.address?.id &&
            order.address?.id !== '00000000-0000-0000-0000-000000000000'
        ) {
            state.order.address = order.address
        }

        if (lock_by_user) {
            state.order.lock_by_user = lock_by_user
            state.order.editable = false
        } else {
            state.order.editable = true
        }
    },
    ADD_DISH_TO_ORDER(state, dish) {
        if (!state.order.dishes) {
            Vue.set(state.order, 'dishes', [])
        }

        const newDish = {
            ...dish,
            temporary_id: window.crypto.randomUUID(),
        }

        state.order.dishes.push(newDish)
    },
    DELETE_DISH_FROM_ORDER(state, { id }) {
        if (!id) return

        const filteredNewDeletedDishes = state.order.dishes.filter(el => {
            if (el.id) return el
            if (el.temporary_id !== id) return el
        })

        const updatedDishes = filteredNewDeletedDishes.map(dish => {
            if (dish.id !== id) return dish

            return {
                ...dish,
                deleted_date: new Date().toISOString(),
            }
        })

        if (state.dirtyDishes.includes(id)) {
            state.dirtyDishes = state.dirtyDishes.filter(el => el !== id)
        }

        state.order.dishes = updatedDishes
    },
    DELETE_ALL_DISHES(state) {
        const dishesCopy = structuredClone(state.order.dishes)

        const dishesWithoutNewItems = dishesCopy.filter(el => el.id)

        const dishesWithDeletedDate = dishesWithoutNewItems.map(el => {
            return { ...el, deleted_date: new Date().toISOString() }
        })

        state.order.dishes = [...dishesWithDeletedDate]
    },

    UPDATE_DISH(state, { dish }) {
        const dishIndex = state.order.dishes.findIndex(el => {
            if (el.id && el.id === dish.id) return true
            if (el.temporary_id && el.temporary_id === dish.temporary_id)
                return true
        })

        const newDishArray = [...state.order.dishes].map((el, index) => {
            if (index !== dishIndex) return el
            return { ...el, ...dish }
        })

        const { dirtyDishes } = state

        const id = dish.id || dish.temporary_id

        if (!dirtyDishes.includes(id)) dirtyDishes.push(id)

        state.order.dishes = [...newDishArray]
    },
    RESET_DIRTY_DISHES(state) {
        state.dirtyDishes = []
    },

    SET_MODE(state, mode) {
        state.mode = mode
    },

    REFRESH_DIRTY(state) {
        state.dirtiesAttributes = []
    },

    ADD_DIRTY(state, nameAttribute) {
        if (state.dirtiesAttributes.indexOf(nameAttribute) === -1) {
            state.dirtiesAttributes.push(nameAttribute)
        }
    },

    REMOVE_DIRTY(state, nameAttribute) {
        const index = state.dirtiesAttributes.indexOf(nameAttribute)
        if (index !== -1) state.dirtiesAttributes.splice(index, 1)
    },

    SET_GUEST_DATE(state, val) {
        state.order.guest.last_modified_date = val
    },

    CLEAR_STORE(state) {
        state.order = structuredClone(blankOrder)
        state.order.address = structuredClone(blankAddress)
        state.permissions = {
            write: [],
            read: [],
        }
        state.restaurantComment = null
        state.notifications = null
        state.isChangeDish = false
        state.limitationPeriods = []
        state.order.send_notification = false
        state.minSumOrder = 0
        state.stopList = []
        state.availabilities = []
    },
    SET_BRAND(state, val) {
        state.order.brand_id = val
    },
    SET_TYPE_TIME(state, val) {
        state.order.time_type = val
    },
    SET_RESTAURANT_ID(state, id) {
        state.order.division_id = id
    },
    SET_TYPE(state, val) {
        state.order.order_type = val
    },
    SET_ADDRESS_NOTE(state, val) {
        state.order.address_note = val
    },
    SET_IS_NOTE_EXCESSIVE(state, val) {
        state.isNoteExcessive = val
    },
    SET_REGION(state, val) {
        if (!state.order.address)
            state.order.address = JSON.parse(JSON.stringify(blankAddress))
        Vue.set(state.order.address, 'region_id', val)
    },
    SET_CITY(state, val) {
        state.order.address.city = val
    },
    SET_SETTLEMENT(state, val) {
        state.order.address.settlement = val
    },
    SET_STREET(state, val) {
        state.order.address.street = val
    },
    SET_HOUSE(state, val) {
        state.order.address.house = val
    },
    SET_LONGITUDE(state, val) {
        state.order.address.longitude = val
    },
    SET_LATITUDE(state, val) {
        state.order.address.latitude = val
    },
    SET_RAW_ADDRESS(state, val) {
        state.order.address.raw_address = val
    },
    SET_FLAT(state, val) {
        state.order.address.flat = val
    },
    SET_ENTRANCE(state, val) {
        state.order.address.entrance = val
    },
    SET_FLOOR(state, val) {
        state.order.address.floor = val
    },
    SET_INTERCOM(state, val) {
        state.order.address.intercom = val
    },
    SET_CALL_INTERCOM(state, val) {
        if (!state.order) state.order = {}
        if (!state.order.parameters) state.order.parameters = []

        const param = state.order.parameters.find(
            p => p.name === DONT_CALL_INTERCOM
        )

        if (param) {
            param.value = `${val}`
        } else {
            state.order.parameters.push({
                name: DONT_CALL_INTERCOM,
                value: `${val}`,
            })
        }
    },
    SET_INIT_COORDINATES(state, coordinates) {
        state.initCoordinates = coordinates
    },
    SET_FIRST_PAYMENT_TYPE(state, { value }) {
        const paymentsCopy = [...state.order.payments]
        if (!paymentsCopy.length) {
            paymentsCopy[0] = {
                payment_type_id: value.id,
                status_id: value.default_status,
                type: {
                    name: value.name,
                },
            }
        } else {
            paymentsCopy[0].payment_type_id = value.id
            paymentsCopy[0].type.name = value.name
        }

        state.order.payments = paymentsCopy
    },

    RESET_PAYMENT_TYPE(state) {
        if (!state.order.payments.length) return

        state.order.payments = state.order.payments.map(payment => ({
            id: payment.id,
            payment_type_id: PAYMENT_TYPES.IDLE,
            final_price: 0,
            type: {
                name: 'не выбран',
            },
        }))
    },

    SET_DISCOUNT(state, newDiscount) {
        const newPromos = state.order.promos
            .map(el => {
                if (!el.id) return
                if (el.type === 'promo') return el
                if (el.type === 'mindbox_fixed') return el

                return { ...el, deleted_date: new Date().toISOString() }
            })
            .filter(Boolean)

        state.order.promos = newDiscount
            ? [
                  ...newPromos,
                  {
                      name: newDiscount.id,
                      type: 'eds_discount',
                      detail: {
                          name: newDiscount.name,
                          value: newDiscount.value,
                      },
                  },
              ]
            : newPromos
    },
    SET_GUEST_NOTES(state, val) {
        if (state.order.guest) {
            state.order.guest.notes = val
        }
    },
    SET_ADDRESS(state, val) {
        if (!val) state.order.address = structuredClone(blankAddress)
        else state.order.address = val
    },
    SET_DATE_SEND(state, val) {
        state.order.date_send = val
    },
    SET_RESULT(state, res) {
        state.resultServer = res
    },

    SET_COOKING_TIME(state, val) {
        state.order.cooking_time = val || 0
    },
    SET_DELIVERY_TIME(state, val) {
        state.order.delivery_time = val || 0
    },
    SET_OVER_TIME(state, val) {
        state.order.over_time = val || 0
    },
    SET_STOP_LIST(state, val) {
        state.stopList = val
    },
    SET_RESTAURANT_COMMENT(state) {
        // TODO comment delivery/cooking
        // TODO Возможно не использ-я
        state.restaurantComment = ''
    },
    SET_NOTIFICATIONS(state, data) {
        if (data) {
            state.notifications = []
            data.forEach(item => {
                state.notifications.push(item)
            })
        } else {
            state.notifications = null
        }
    },
    SET_SEND_NOTIFICATION(state, { order }) {
        state.order.send_notification = order.send_notification
    },
    SET_GUEST_FROM_CALLING(state, { guest }) {
        state.guest_calling = guest
    },

    SET_IS_CHANGE_DISH(state, val) {
        state.isChangeDish = val
    },

    SET_LIMITATION_PERIODS(state, val) {
        state.limitationPeriods = val
    },
    SET_AVAILABILITIES(state, { items }) {
        state.availabilities = items || []
    },
    SET_SECTOR(state, value) {
        state.order.sector = value
        state.order.sector_id = value?.id || null
    },
    SET_ADDRESS_AVAILABLE(state, value) {
        state.addressAvailable = value
    },
    TRIGGER_UPDATE_DATE(state, value) {
        state.updateDate = value
    },
    SET_REASON_CHANGE_TIME(state, value) {
        state.reasonChangeTime = value
    },
    SET_REASON_CHANGES(state, value) {
        state.reasonChanges = value
    },
    SET_HAS_RESEND_DISHES(state, value) {
        state.hasResendDishes = value
    },
    SET_RESEND_DISHES(state, value) {
        state.resendDishes = value
    },
    SET_MIN_SUM(state, value) {
        state.minSumOrder = value || 0
    },
    SET_PREDICTED_DELIVERY_DATE(state, value) {
        state.predictedDeliveryDate = value
    },
    SET_PREDICTED_TIME(state, value) {
        state.predictedTime = value
    },
    SET_PREDICTED_AVAILABLE(state, value) {
        state.predictedAvailable = value
    },
    SET_PREDICTED_INTERVALS(state, value) {
        state.predictedIntervals = value
    },
    SET_WAIT_SAVING(state, val) {
        state.waitSaving = val
    },
    SET_TIME_TYPE(state, val) {
        state.order.time_type = val
    },

    SET_RESTAURANT(state, val) {
        state.order.division_id = val
    },
    SET_SECOND_PAYMENT_TYPE(state, val) {
        if (!state.order.payments || state.order.payments?.length <= 1) return

        const secondPaymentId = state.order.payments[1]?.id
        if (!val && secondPaymentId) {
            state.order.payments = [
                state.order.payments[0],
                {
                    id: secondPaymentId,
                    price: 0,
                    final_price: 0,
                },
            ]
            return
        }

        const secondPayment = {
            ...state.order.payments[1],
            payment_type_id: val.id,
            type: {
                name: val.name,
            },
        }

        Vue.set(state.order, 'payments', [
            state.order.payments[0],
            secondPayment,
        ])
    },
    SET_EMPTY_SECOND_PAYMENT(state, finalOrderPrice) {
        state.order.payments = [
            { ...state.order.payments[0], final_price: finalOrderPrice },
            {
                ...state.order.payments[1],
                price: 0,
                final_price: 0,
                change_from: null,
                payment_type_id: null,
                type: {
                    name: null,
                },
            },
        ]
    },
    SET_FIRST_PAYMENT_FINAL_PRICE(state, val) {
        if (val < 0) return

        if (!state.order.payments || state.order.payments?.length < 1) return

        const [firstPayment, ...restPayments] = state.order.payments

        state.order.payments = [
            {
                ...firstPayment,
                final_price: val,
            },
            ...restPayments,
        ]
    },
    SET_SECOND_PAYMENT_FINAL_PRICE(state, val) {
        if (val < 0) return

        if (!state.order.payments || state.order.payments?.length < 2) return

        state.order.payments = [
            state.order.payments[0],
            {
                ...state.order.payments[1],
                final_price: val,
            },
        ]
    },
    SET_FIRST_PAYMENT_CHANGE_FROM(state, val) {
        if (!state.order.payments || !state.order.payments?.length) return
        if (!val) state.order.payments[0].change_from = 0

        state.order.payments[0].change_from = val
    },
    SET_SECOND_PAYMENT_CHANGE_FROM(state, val) {
        if (!val) state.order.payments[0].change_from = 0

        if (!state.order.payments || state.order.payments?.length < 2) return

        state.order.payments = [
            state.order.payments[0],
            {
                ...state.order.payments[1],
                change_from: val,
            },
        ]
    },
    DELETE_SECOND_PAYMENT(state) {
        state.order.payments = [state.order.payments[0]]
    },

    SET_MAIN_PAYMENT_TRANSACTION_ID(state, transactionId) {
        state.order.payments.splice(0, 1, {
            ...state.order.payments[0],
            transaction_id: transactionId,
        })
    },

    SET_IS_INTERVALS_AVAILABLE(state, payload) {
        state.isIntervalsAvailable = payload
    },

    SET_ORIGINAL_ORDER_FIRST_PAYMENT(state, { payments }) {
        state.originalOrderFirstPaymentType =
            payments?.length > 0 ? structuredClone(payments[0]) : {}
    },

    SET_DEFAULT_ORIGINAL_ORDER_FIRST_PAYMENT(state) {
        state.originalOrderFirstPaymentType = {}
    },

    SET_STANDARD_COOKING_TIME(state, val) {
        state.order.standard_cooking_time = val
    },
    SET_STANDARD_DELIVERY_TIME(state, val) {
        state.order.standard_delivery_time = val
    },

    SET_DELIVERY_AVAILABILITY_DATA(state, data) {
        state.deliveryAvailabilityData = data
    },

    SET_ORDER_CONTRACTOR(state, contractor) {
        state.order.contractor = contractor
    },

    SET_SECOND_PAYMENT_TRANSACTION_ID(state, val) {
        if (!state.order.payments || state.order.payments?.length < 2) return

        state.order.payments = [
            state.order.payments[0],
            {
                ...state.order.payments[1],
                transaction_id: val ?? '',
            },
        ]
    },

    SET_IS_ADDITIONAL_TRANSACTION_INVALID(state, val) {
        state.isAdditionalTransactionInvalid = val
    },

    SET_IS_MAIN_TRANSACTION_INVALID(state, payload) {
        state.isMainTransactionInvalid = payload
    },
}
